import logo from './logo.svg';
import './App.css';


function App() {
  return (
      <div className="App">
          <div className="image-semaf-wrapper">
              <img className="image-semaf-desk" src="./sema.svg" alt="semafor" />
              <img className="image-semaf-desk a" src="./sem.svg" alt="semafor" />
              <img className="image-semaf" src="./sema-desk.svg" alt="semafor" />
              <img className="image-semaf a" src="./sem-desk.svg" alt="semafor" />
          </div>
          <div className="image-still"></div>
          <a href="mailto:info@0512.cz">
              <div className="image-kontakt"></div>
          </a>
      </div>
  );
}

export default App;